import { getErrorMessage } from './error'
import store from '@/store'

/**
   * Exibe uma notificação no canto inferior da tela,
   * desaparece em um intervalo de tempo
   *
   * @param {string} mensgem A mensagem que aparece na notificação
   */
export const retPermissao = (programa, role) => {
  /**
   * Método que verifica permissão para: acessar, incluir, alterar e excluir *
   * @param {string} programa Nome do programa *
   * @param {string} role acessar, incluir, alterar, excluir
   * @returns {true ou false} *
   * */
  var passo
  for (passo = 0; passo <= store.modulos.length - 1; passo++) {
    if (store.modulos[passo]['programa'] === programa) {
      if (store.modulos[passo][role] === '1') {
        return true
      } else {
        showError('Acesso negado')
        return false
      }
    }
  }
}
export const showFlash = msg => {
  alert.toast(msg)
}

/**
   * Exibe uma mensagem em uma caixa de diálogo modal
   *
   * @param {string} mensagem A mensagem a ser exibida
   */
export const showDialog = msg => {
  alert.ok(msg)
}

export const showCancel = msg => {
  alert.cancelada(msg)
}

/**
   * Exibe uma mensagem pedindo a confirmação de algo ao usuário
   *
   * @param {string} mensagem A mensagem exibida para o usuário
   * @param {function} callback Uma função de callback que é executada após o usuário selecionar a opção
   */
export const showConfirm = (msg, callback) => {
  alert.confirm(msg, callback)
}

/**
   * Exibe uma notificação de erro no canto inferior da tela,
   * desaparece em um intervalo de tempo
   *
   * @param {string} mensgem A mensagem que aparece na notificação
   */
export const showFlashError = msg => {
  alert.toastError(msg)
}

/**
 * Exibe uma mensagem de erro
 * @param {*} error
 */
export const showError = error => {
  const messages = getErrorMessage(error)
  alert.error(messages[0], messages[1])
}

/**
 * Configurações internas do alert.
 * Não altere os valores desta propriedade
 */
export const alert = {
  config: {
    snackbar: {
      color: 'primary',
      timeout: 3000,
      text: '',
      show: false
    },
    dialog: {
      show: false,
      color: 'primary',
      text: '',
      text2: '',
      title: '',
      icon: ''
    },
    confirm: {
      show: false,
      text: '',
      callback: null,
      choice: function (result) {
        alert.config.confirm.show = false
        alert.config.confirm.callback(result)
      }
    }
  },
  toast: function (msg) {
    this.config.snackbar.color = 'primary'
    this.config.snackbar.text = msg
    this.config.snackbar.timeout = 3000
    this.config.snackbar.show = true
  },
  toastError: function (msg) {
    this.config.snackbar.color = 'error'
    this.config.snackbar.text = msg
    this.config.snackbar.timeout = 4000
    this.config.snackbar.show = true
  },
  ok: function (msg) {
    this.config.dialog.title = ''
    this.config.dialog.icon = 'done_outline'
    this.config.dialog.color = 'primary'
    this.config.dialog.text = msg
    this.config.dialog.text2 = ''
    this.config.dialog.show = true
  },
  cancelada: function (msg) {
    this.config.dialog.title = 'Atenção'
    this.config.dialog.icon = 'done_outline'
    this.config.dialog.color = '#2A3B4D'
    this.config.dialog.text = msg
    this.config.dialog.text2 = ''
    this.config.dialog.show = true
  },
  error: function (message1, message2) {
    this.config.dialog.title = 'Atenção'
    this.config.dialog.icon = 'error_outline'
    this.config.dialog.text = message1
    this.config.dialog.text2 = message2
    this.config.dialog.color = 'error'
    this.config.dialog.show = true
  },
  confirm: function (msg, callback) {
    this.config.confirm.text = msg
    this.config.confirm.callback = callback
    this.config.confirm.show = true
  }
}
